import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';

import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import GetMarketplaceDisplayName from '../../../../components/data-driven-logo/get-marketplace-display-name';
import { Tooltip } from 'ui-components/components/tooltip';

import messages from './messages';
import style from './style.module.less';

export const GatedMarketplace = ({ marketplaceId = -1 }) => {
  const intl = useIntl();
  const displayName = GetMarketplaceDisplayName(marketplaceId);
  const name = intl.formatMessage(displayName, displayName.values);
  return (
    <div className={style['error-icon']}>
      <Tooltip position='bottom' text={<FormattedMessage {...messages.gatedMarketplaceTooltip} values={{ name }} />}>
        <span>
          <FontAwesomeIcon className={style['error-icon']} icon={faExclamationCircle} />
        </span>
      </Tooltip>
    </div>
  );
};
